<div class="resource-page">
  <mat-card class="page-header-card">
    <div class="header-row">
      <div>
        <h1>{{ title }}</h1>
        @if (subtitle) {
          <p>{{ subtitle }}</p>
        } @else {
          <p>Showing data from <code>{{ apiPath }}</code></p>
        }
      </div>
      <div class="header-actions">
        <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="searchText" (keyup.enter)="load()" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-stroked-button type="button" (click)="load()" [disabled]="loading()">
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
      </div>
    </div>
  </mat-card>

  @if (loading()) {
    <div class="state-block">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading…</span>
    </div>
  } @else if (error()) {
    <mat-card class="state-card error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong>Could not load data</strong>
        <p>{{ error() }}</p>
      </div>
      <button mat-button color="primary" type="button" (click)="load()">Retry</button>
    </mat-card>
  } @else if (!rows().length) {
    <mat-card class="state-card">
      <mat-icon>inbox</mat-icon>
      <div>
        <strong>No records</strong>
        <p>No items were returned for this resource.</p>
      </div>
    </mat-card>
  } @else {
    <mat-card class="table-card">
      <div class="meta">{{ totalCount() }} record(s)</div>
      <div class="table-wrap">
        <table mat-table [dataSource]="rows()" class="resource-table">
          @for (col of columns(); track col) {
            <ng-container [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
              <td mat-cell *matCellDef="let row">{{ cellValue(row, col) }}</td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="columns()"></tr>
          <tr mat-row *matRowDef="let row; columns: columns();"></tr>
        </table>
      </div>
    </mat-card>
  }
</div>
